import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { RestService } from 'src/app/services/rest/rest.service';

@Component({
  selector: 'app-ajustes',
  templateUrl: './ajustes.page.html',
  styleUrls: ['./ajustes.page.scss'],
})
export class AjustesPage implements OnInit {

  bankAccount: any = {} as any;
  aheAccount: any = {} as any;
  iceVentureAccount: any = {} as any;
  garajesAccount: any = {} as any;
  settings: any[] = [];

  constructor(private utils: UtilsService,
              private rest: RestService) { }

  async ngOnInit() {
    await this.getSettings();
  }

  /*            Funcion original
  async getSettings() {
    try {
      await this.utils.showLoading();
      const resp: any = await this.rest.getSettings();
      if (resp) {
        console.log(resp.body);
        this.settings = resp.body;
        if (this.settings && this.settings.length > 0) {
          this.settings.forEach(
            setting => {
              if (setting.key === 'bankAccount') {
                this.bankAccount = setting;
              }
            }
          );
        }
      }
      await this.utils.hideLoading();
    } catch (error) {
      await this.utils.hideLoading();
      console.log(error);
    }
  }
  */

  async getSettings() {
    try {
      await this.utils.showLoading();
      const resp: any = await this.rest.getSettings();
      if (resp && resp.body && resp.body.length > 0) {
        this.bankAccount = resp.body.find(setting => setting.key === 'bankAccount');
        this.aheAccount = resp.body.find(setting => setting.key === 'ahe');
        this.iceVentureAccount = resp.body.find(setting => setting.key === 'iceventure');
        this.garajesAccount = "ES80 0081 4148 1400 0135 1441";
      }
      await this.utils.hideLoading();
    } catch (error) {
      await this.utils.hideLoading();
      console.error(error);
    }
  }
  

/*     Funcion original
  async save() {
    try {
      await this.utils.showLoading();
      const resp: any = await this.rest.editSetting(this.bankAccount);
      if (resp) {
        await this.utils.hideLoading();
        await this.utils.showToast('Cambios guardados con éxito', 'success');
      } else {
        await this.utils.hideLoading();
        await this.utils.showToast('Hubo un error al guardar los cambios', 'danger');
      }
    } catch (error) {
      await this.utils.hideLoading();
      await this.utils.showToast('Hubo un error al guardar los cambios', 'danger');
      console.log(error);
    }
  }
  */
 

  async save(account: any) {
    try {
      await this.utils.showLoading();
      const resp: any = await this.rest.editSetting(account);
      if (resp) {
        await this.utils.hideLoading();
        await this.utils.showToast('Cambios guardados con éxito', 'success');
      } else {
        await this.utils.hideLoading();
        await this.utils.showToast('Hubo un error al guardar los cambios', 'danger');
      }
    } catch (error) {
      await this.utils.hideLoading();
      await this.utils.showToast('Hubo un error al guardar los cambios', 'danger');
      console.log(error);
    }
  }
  
  

}
